<div class="grid no-gutters" style="align-items: center">
  @if (filterModel$ | async; as filterModel) {
    <div class="col-11">
      <div class="flex align-items-center mb-2">
        <p-checkbox
          [binary]="true"
          [ngModel]="true"
          [readonly]="filterModel.filterDto.readonly"
          [class]="
            filterModel.filterDto.readonly ? 'readonly-filter-checkbox' : ''
          "
        >
        </p-checkbox>
        <label class="ml-2" [for]="'filter-' + filterModel.filterDto.id">
          {{ filterModel.filterDto.description }}:
        </label>
      </div>
      <p-inputNumber
        id="threshold_filter"
        [minFractionDigits]="0"
        [maxFractionDigits]="maxFractionDigits"
        [suffix]="units"
        [(ngModel)]="editThreshold"
        [showButtons]="true"
        [step]="increment"
        [min]="minThreshold"
        [max]="maxThreshold"
        (onInput)="saveNewValue($event)"
      >
      </p-inputNumber>
    </div>
  }
  @if (filterModel$ | async; as filterModel) {
    <div [ngClass]="{ 'col-1': true }">
      <span
        class="pi pi-question-circle"
        [pTooltip]="filterModel.filterDto.help_text"
      ></span>
    </div>
  }
</div>
